
import React from 'react';

const ChurchSteepleProcess = () => {
  const steps = [
    {
      number: 1,
      title: "Reverent Assessment",
      description: "Our process begins with a thorough yet respectful evaluation of your steeple's condition. We document existing damage, historical elements, and structural concerns, working closely with church leadership to understand your priorities and budget considerations.",
      detail: "We create a comprehensive assessment of your steeple's current condition while following preservation technology and training protocols."
    },
    {
      number: 2,
      title: "Custom Restoration Plan",
      description: "Unlike standard roofing jobs, steeple restoration requires a tailored approach. We develop a detailed plan that addresses immediate concerns while preserving historical elements and enhancing long-term durability. This includes material selection that matches original aesthetics while providing modern protection.",
      detail: "Our restoration plans integrate findings from moisture mapping, structural load analysis, and historical materials research to create solutions that meet modern building standards."
    },
    {
      number: 3,
      title: "Material Sourcing & Preparation",
      description: "We source historically appropriate materials that match your steeple's original components while offering enhanced durability. For historic structures, we work with specialist suppliers of architectural preservation materials to ensure authenticity.",
      detail: "Our material selection follows recommendations for historic roofing materials and standards for wood, metal, and masonry elements, utilizing premium products from leading manufacturers."
    },
    {
      number: 4,
      title: "Skilled Craftsmanship",
      description: "Our steeple specialists employ both traditional woodworking techniques and advanced restoration methods. Whether recreating ornamental elements, repairing structural damage, or installing modern weatherproofing systems, every detail receives trophy-quality attention.",
      detail: "Our master craftsmen are certified in heritage skills including traditional joinery techniques, hand-tool woodworking, and historic finishing methods."
    },
    {
      number: 5,
      title: "Weather & Environmental Protection",
      description: "Eastern North Carolina's climate presents unique challenges for church steeples. Our solutions incorporate hurricane-resistant reinforcements, advanced moisture barriers, and UV-resistant finishes that protect against our region's specific environmental conditions.",
      detail: "Our weather protection systems incorporate climate data to address region-specific environmental stressors documented in Eastern North Carolina."
    },
    {
      number: 6,
      title: "Final Inspection & Documentation",
      description: "Upon completion, we conduct a final inspection with church leadership, providing detailed documentation of the work performed and specific maintenance recommendations to protect your investment for decades to come.",
      detail: "Every completed project includes a digital preservation portfolio with before/after documentation, material specifications, and a customized maintenance schedule following preservation best practices and ventilation guidelines."
    }
  ];

  return (
    <section id="process" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold mb-4 text-center">Our 6-Step Church Steeple Restoration Process</h2>
        
        <p className="text-center mb-12">Our systematic approach respects both structural integrity and historical significance, following protocols established by the <a href="https://www.nps.gov/tps/how-to-preserve/briefs/4-roofing.htm" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">National Park Service Preservation Brief 4</a> and <a href="https://www.apti.org/" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">Association for Preservation Technology International</a> standards.</p>
        
        <div className="space-y-8">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col md:flex-row gap-6">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full bg-brand-trophy-gold text-white flex items-center justify-center text-xl font-bold">
                  {step.number}
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                <p className="mb-3">{step.description}</p>
                <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded">{step.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChurchSteepleProcess;
